import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { areRadioGroupsStatesEqual, RADIO_GROUPS_INITIAL_STATE } from './cost-to-build-client-ui-radio-groups.state';
import type { RadioGroupsState } from './cost-to-build-client-ui-radio-groups.types';

export const RadioGroupsStore = signalStore(
    withState(RADIO_GROUPS_INITIAL_STATE),
    withComputed((store) => ({
        state: computed<RadioGroupsState>(() => ({
            name: store.name(),
            options: store.options(),
            value: store.value(),
        })),
    })),
    withMethods((store) => {
        const setState = (patch: Partial<RadioGroupsState>) => {
            const nextState: RadioGroupsState = {
                ...store.state(),
                ...patch,
            };

            if (areRadioGroupsStatesEqual(store.state(), nextState)) {
                return;
            }

            patchState(store, patch);
        };

        return {
            selectValue(value: string) {
                setState({ value });
            },
            setState,
        };
    })
);
